const getTagDevIconName = (tagName) => {

         //replace common tech w ones devicon.dev can understand
       
     //     let keywordArr = [
     //           'c#',
     //          'wpf',
     //          'aspnet',
     //          'adonet',
     //          'net',
     //          'winform',
     //          'winforms',
     //          'java',
     //          'spring',
     //          'javascript',
     //          'grunt',
     //          'gulp',                                               
     //          'express',
     //          'express.js',
     //          'expressjs',
     //          'angular',
     //          'angularjs',
     //          'angular.js',
     //          'react',
     //          'reactjs',
     //          'react.js',
     //          'nodejs',
     //          'node.js',
     //          'vuejs',
     //          'vue',
     //          'babel',
     //          'redux',
     //          'python',
     //          'django',
     //          'flask',
     //          'c++',
     //          'f#',
     //          'xaml',
     //          'swift',
     //          'xamarin',
     //          'ionic',
     //          'dart',
     //          'flutter',
     //          'react native',
     //          'react-native',
     //          'objective-c',
     //          'obj-c',
     //          'jenkins',
     //          'maven',
     //          'docker',
     //          'ansible',
     //          'kubernetes',
     //          'sonar',
     //          'aws',
     //          'amazon web services',
     //          'azure',
     //          'git',
     //          'github',
     //          'svn',
     //          'jira',
     //          'cucumber',
     //          'restful',
     //          'rest api',
     //          'mysql',
     //          'sql',
     //          'oracle',
     //          'couchdb',
     //          'bash',
     //          'bitbucket',
     //          'firebase',
     //          'rails',
     //          'npm',
     //          'yarn',
     //          'postgresql',
     //          'mongodb',
     //          'agile',
     //          'golang',
     //          'php',
     //          'drupal',
     //          'codeigniter',
     //          'laravel',
     //          'symfony',
     //          'yii',
     //          'wordpress',
     //          'magento',
     //          'mean',
     //          'mern',
     //          'nginx',
     //          'apache',
     //          'ajax',
     //          'jquery',
     //          'css',
     //          'css3',
     //          'html',
     //          'html5',
     //          'bootstrap',
     //          'perl',
     //          'ruby',
     //          'typescript',
     //          'haskell',
     //          'kotlin',
     //          'ssrs',
     //          'ssis',
     //          'crystal-reports',
     //          'entity-framework',
     //          'wcf',
     //          'webforms',
     //          'xml',
     //          'json',
     //          'soa',
     //          'microservice',
     //          'microservices',
     //          'soa',
     //          'iis',
     //          'ios',
     //          'android',
     //          'windows',
     //          'linux',
     //          'debian',
     //          'unix',
     //          'photoshop',
     //          'webpack',
     //          'elixir',
     //          'graphql',
     //          'haskell',
     //          'heroku',
     //          'mocha',
     //          'matlab',
     //          'objective-c',
     //          'redhat',
     //          'spring',
     //          'ubuntu',
     //          'woocommerce',
     //          'zend',
     //          'ec2',
     //          'cloud',
     //          'firefox',
     //          'chrome',
     //          'safari',
     //          'cakephp',
     //          'mvc',
     //          'mvvm',
     //          'singleton',
     //          'mvp',
     //          'core',
     //          'confluence',
     //          'tailwind',
     //          'clojure',
     //          'd3',
     //          'd3js',
     //          'debian',
     //          'digitalocean',
     //          'erlang',
     //          'gimp',
     //          'gitlab',
     //          'go',
     //          'haskell',
     //          'jasmine',
     //          'less',
     //          'sass',
     //          'ssh',
     //          'tomcat',
     //          'rabbitmq'
     //     ];
console.log("TAGNAME", tagName)
     tagName = tagName.toLowerCase()

     let asIsTagNames = [
        
          'wpf',
          'aspnet',
          'adonet',
          'net',
          'winform',
          'winforms',
          'java',
          'spring',
          'javascript',
          'typescript',
          'grunt',
          'gulp',                                               
          'express',
          'express.js',
          'expressjs',
          'angularjs',
          'nodejs',
          'node.js',
          'vuejs',
          'vue',
          'babel',
          'redux',
          'python',
          'django',
          'flask',
          'c++',
          'f#',
          'xaml',
          'swift',
          'xamarin',
          'ionic',
          'dart',
          'flutter',
          'objective-c',
          'obj-c',
          'jenkins',
          'maven',
          'docker',
          // 'ansible',
          'kubernetes',
          'terraform',
          // 'chef',
          'sonar',
          'amazon web services',
          'azure',
          'git',
          'github',
          'svn',
          'jira',
          'cucumber',
          'restful',
          'rest api',
          'mysql',
          'oracle',
          'couchdb',
          'bash',
          'bitbucket',
          'firebase',
          'rails',
          'npm',
          'yarn',
          'postgresql',
          'mongodb',
          'agile',
          'golang',
          'php',
          'drupal',
          'codeigniter',
          'laravel',
          'symfony',
          'yii',
          'wordpress',
          'magento',
          'mean',
          'mern',
          'nginx',
          'apache',
          'ajax',
          'jquery',
          'css3',
          'html5',
          'bootstrap',
          'tailwindcss',
          'perl',
          'ruby',
          'haskell',
          'kotlin',
          'ssrs',
          'ssis',
          'crystal-reports',
          'entity-framework',
          'wcf',
          'webforms',
          'xml',
          'json',
          'soa',
          'microservice',
          'microservices',
          'soa',
          'iis',
          'ios',
          'android',
          'windows',
          'linux',
          'debian',
          'unix',
          'photoshop',
          'webpack',
          'elixir',
          'graphql',
          'haskell',
          'heroku',
          'mocha',
          'matlab',
          'redhat',
          'spring',
          'ubuntu',
          'woocommerce',
          'zend',
          'ec2',
          'cloud',
          'firefox',
          'chrome',
          'safari',
          'cakephp',
          'mvvm',
          'singleton',
          'mvp',
          'core',
          'confluence',
          'tailwind',
          'clojure',
          'd3',
          'd3js',
          'debian',
          'digitalocean',
          'erlang',
          'gimp',
          'gitlab',
          'go',
          'haskell',
          'jasmine',
          'less',
          'sass',
          'ssh',
          'tomcat',
          'rabbitmq'
     ];
    
    const getExceptionTagName = (tagName) => {
     switch (tagName) {
          // Microsoft
          case 'c#':
               return 'csharp'
          case 'f#':
               return 'fsharp'
          case 'aspnet': 
               return 'dot-net'
          case 'asp.net':
               return 'dot-net'
          case 'adonet':
               return 'dot-net'
          case 'ado.net':
               return 'dot-net'
          case '.net': 
               return 'dot-net'
          case 'net':
               return 'dot-net'
          case 'asp.net core':
               return 'dotnetcore'
          case '.net core':
               return 'dotnetcore'

          // Cloud and DevOps
          case 'aws':
               return 'amazonwebservices'
          case 'amazon web services':
               return 'amazonwebservices'
          case 'amazonwebservices':
               return 'amazonwebservices'
          case 'azure':
               return 'azure'
          case 'sql': 
               return 'azuresqldatabase'

          // FrontEnd
          case 'angular.js':
               return 'angularjs'
          case 'angularjs':
               return 'angularjs'
          case 'angular':
               return 'angularjs'
          case 'react.js':
               return 'react'
          case 'reactjs':
               return 'react'
          case 'react native':
               return 'react'
          case 'react':
               return 'react'
          case 'vue.js':
               return 'vuejs'
          case 'vuejs':
               return 'vuejs'
          case 'vue':
               return 'vuejs'
          case 'expressjs':
               return 'express'
          case 'express.js':
               return 'express'
          case 'express':
               return 'express'
          case 'ios':
               return 'apple'
          case 'macos':
               return 'apple'
          case 'c++':
               return 'cplusplus'
          case 'sql':
               return 'mysql'
          case 'postgres':
               return 'postgresql'
          case 'unix':
               return 'linux'
          case 'golang':
               return 'go'
          case 'css':
               return 'css3'
          case 'html':
               return 'html5'
          case 'objective-c':
          case 'obj-c':
               return 'objectivec'
          case 'windows':
               return 'windows8'
          case 'd3':
               return 'd3js'
          default:
               return null
               break;
     }}



     if (asIsTagNames.includes(tagName)) {
          return tagName // returns the tag name as it is input (php -> php)
     }
     else {
          return getExceptionTagName(tagName) // returns either exception tag name (c# -> csharp) or null if not found
     }


     
    }

    export default getTagDevIconName
    
    